import React, { useState, useEffect } from "react";
import { useAddToHomescreenPrompt } from "../../useAddToHomescreenPrompt";
import "./A2HSPrompt.css";
import { AiOutlineClose } from "react-icons/ai";
import { getDefPromt, setDefPromt } from "../../lib/utility";

const A2HSPrompt = () => {
  const [prompt, promptToInstall] = useAddToHomescreenPrompt();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const isDismissed = sessionStorage.getItem("a2hs-dismissed") === "true";
    const isStandalone =
      window.matchMedia("(display-mode: standalone)").matches ||
      window.navigator.standalone === true;
    const availablePrompt = prompt || getDefPromt();

    if (availablePrompt && !isDismissed && !isStandalone) {
      setDefPromt(availablePrompt);
      setIsVisible(true);
    }
  }, [prompt]);

  useEffect(() => {
    const handleAppInstalled = () => {
      setIsVisible(false);
      sessionStorage.setItem("a2hs-dismissed", "true");
    };

    window.addEventListener("appinstalled", handleAppInstalled);
    return () => window.removeEventListener("appinstalled", handleAppInstalled);
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    sessionStorage.setItem("a2hs-dismissed", "true");
  };

  const handleAddNow = async () => {
    try {
      const choice = await promptToInstall();
      console.log("A2HS user choice:", choice?.outcome);
      setIsVisible(false);
    } catch (error) {
      console.error("Failed to prompt installation:", error);
    }
  };

  if (!isVisible) return null;

  return (
    <div className="a2hs-modal-overlay">
      <div className="a2hs-modal">
        <button
          className="a2hs-close-btn"
          onClick={handleClose}
          aria-label="Close Add to Home Screen prompt"
        >
          <AiOutlineClose size={24} />
        </button>
        <div className="a2hs-content">
          <p className="a2hs-text">
            Hi!
            <br />
            Add VisaLancer App to your home screen for quick access.
          </p>
          <button className="a2hs-add-btn" onClick={handleAddNow}>
            Add Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default A2HSPrompt;
